import * as React from 'react';
import translate from '../../locale/translate';

import HeaderLink from './HeaderLink';

import IReportSettings from '../../interfaces/IReportSettings';
import ReportTemplate from '../../store/models/ReportTemplate';

interface IProps {
    isDirty: boolean,
    isSaved: boolean,
    isSaving: boolean,
    reportTemplate: ReportTemplate
    reportSettings: IReportSettings,
    onSave: EventListener,
    onOpen: EventListener,
}

export default class HeaderButtons extends React.Component<IProps, void> {
    static propTypes = {
        isDirty: React.PropTypes.bool,
        isSave: React.PropTypes.bool,
        isSaving: React.PropTypes.bool,
        reportTemplate: React.PropTypes.object,
        reportSettings: React.PropTypes.object.isRequired,
        onSave: React.PropTypes.func.isRequired,
        onOpen: React.PropTypes.func.isRequired,
    };

    renderOpenButton({onOpen}) {
        return <a className="btn btn-default navbar-btn m-r-xs" onClick={onOpen} title={translate.gettext('Open template')}>
            <i className="fa fa-fw fa-folder-open" />
        </a>;
    }

    renderSaveButton({ isDirty, isSaved, isSaving, onSave }) {
        let disabled = true;
        let title = translate.gettext('Save');
        let iconExtraCls = 'fa-floppy-o';

        if (isDirty && !isSaving) {
            disabled = false;
            title = translate.gettext('Save');
            iconExtraCls = 'fa-floppy-o'
        } else if (isSaved) {
            title = translate.gettext('Saved');
            iconExtraCls = 'fa-check';
            disabled = true;
        } else if (isSaving) {
            title = translate.gettext('Saving');
            iconExtraCls = 'fa-circle-o-notch fa-spin';
            disabled = true;
        }

        const iconCls = `fa fa-fw ${iconExtraCls}`;

        return <button type="button" className="btn btn-primary navbar-btn" onClick={onSave} disabled={disabled} title={title}>
            <i className={iconCls} />
        </button>;
    }

    renderPreviewButton({ isDirty, isSaving, isSaved, reportSettings, reportTemplate }) {
        let disabled = true;
        const { customerId, startMs, endMs } = reportSettings;
        const url = `/print.html?customerId=${customerId}&rtId=${reportTemplate.rtId}&startMs=${startMs}&endMs=${endMs}`;

        if (isDirty || isSaving || !reportTemplate.rtId) {
            disabled = true;
        } else {
            disabled = false;
        }

        return <a href={url} target="_blank" disabled={disabled} className="btn btn-default navbar-btn m-r-xs" title={translate.gettext('Print preview')}>
            <i className="fa fa-fw fa-print" />
        </a>;
    }

    render() {
        return (
            <ul className="nav navbar-nav navbar-right m-r-xxs">
                {this.renderOpenButton(this.props)}
                {this.renderPreviewButton(this.props)}
                {this.renderSaveButton(this.props)}
            </ul>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/header/HeaderButtons.tsx